const EXACT_NEXT_PATHS = new Set(['/settings/notifications', '/settings', '/dashboard']);

/** Path to open after login. Inbox may include ?conversationId= from the message email. */
export function safeNextPath(value: string | null): string | null {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) {
    return null;
  }
  if (value.includes('://')) return null;
  const pathOnly = value.split('?')[0];
  if (pathOnly === '/inbox') return value;
  return EXACT_NEXT_PATHS.has(value) ? value : null;
}

/** Login URL that returns the visitor to this inbox thread after they sign in. */
export function loginUrlForInbox(pathname: string, search: string): string {
  const next = `${pathname}${search}`;
  return `/login?next=${encodeURIComponent(next)}`;
}
